__turbopack_context__.v({
  "container": "styles-module-scss-module__1pwZxq__container",
  "playPauseButtonContainer": "styles-module-scss-module__1pwZxq__playPauseButtonContainer",
});
